const InclusionsExclusions = ({ inclusions, exclusions }) => {
  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8 max-w-2xl mx-auto">
      {/* ✅ Inclusions */}
      <div className="mb-8 relative pl-4">
        {/* Dot and line similar to timeline */}
        <div className="absolute left-0 top-2 w-1 h-3 bg-green-600 rounded-full z-10"></div>

        <h3 className="text-lg font-bold text-green-600 mb-2">Inclusions</h3>
        <div className="space-y-2 text-sm text-gray-700 mb-4">
          {inclusions.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </div>

        {/* Bonus section */}
        {/* {bonus && (
          <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-md text-sm text-yellow-900">
            🎁 <strong>Bonus:</strong> {bonus}
          </div>
        )} */}
      </div>

      {/* ❌ Exclusions */}
      <div className="relative pl-4">
        {/* Dot and line */}
        <div className="absolute left-0 top-2 w-1 h-3 bg-red-600 rounded-full z-10"></div>
        {/* <div className="absolute left-[7px] top-3 bottom-0 w-px bg-red-400"></div> */}

        <h3 className="text-lg font-bold text-red-600 mb-2">Exclusions</h3>
        <div className="space-y-2 text-sm text-gray-700">
          {exclusions?.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InclusionsExclusions;
